import { useCallback, useState } from 'react';
import { ApiError, useCallApi } from './common';
import {
  TypingApi,
  TypingInsertResultRequest,
  TypingInsertResultResponse,
  TypingResult,
  TypingInsertResultResponseData,
  TypingGetResultResponse,
} from '../../api';

import { THEMES } from '../../constants/Consts';
export const useTypingResult = () => {
  const [error, setError] = useState<ApiError | null>(null);
  const { callApi, defaultConfiguration } = useCallApi();
  const [loading, setLoading] = useState<boolean>(false);
  const [typingResults, setTypingResults] = useState<TypingResult[] | undefined>(undefined);
  const [updatedTypingResult, setUpdatedTypingResult] = useState<TypingInsertResultResponseData | undefined>(undefined);

  const getTypingResults = useCallback(
    async (themeType: THEMES, gradeNumber: number | null = null) => {
      // if (false) {
      // TODO: 有効期限切れの場合、トークンを再取得するように修正。
      // return;
      // }
      setLoading(true);
      setError(null);
      const api = new TypingApi(await defaultConfiguration());
      const response = await callApi<TypingGetResultResponse, null>(null, () => api.apiV1TypingResultsGet(themeType, gradeNumber));

      if (response.success) {
        setTypingResults(response.success.data);
      } else {
        setError(response.error);
      }
      setLoading(false);
      return response;
    },
    [callApi, defaultConfiguration]
  );

  const insertTypingResult = useCallback(
    async (themeType: THEMES, gradeNumber: number, score: number, correctTypeCount: number, missTypeCount: number) => {
      // if (!false) {
      // TODO: 有効期限切れの場合、トークンを再取得するように修正。
      // return;
      // }

      setLoading(true);
      setError(null);
      const api = new TypingApi(await defaultConfiguration());

      const params: TypingInsertResultRequest = {
        themeType: themeType,
        gradeNumber: gradeNumber,
        score: score,
        correctTypeCount: correctTypeCount,
        missTypeCount: missTypeCount,
      };

      const response = await callApi<TypingInsertResultResponse, TypingInsertResultRequest>(params, (params) => api.apiV1TypingResultsPost(params));

      if (response.success) {
        setUpdatedTypingResult(response.success.data);
      } else {
        setError(response.error);
      }
      setLoading(false);
      return response;
    },
    [callApi, defaultConfiguration]
  );

  return {
    error,
    loading,
    getTypingResults,
    insertTypingResult,
    typingResults,
    updatedTypingResult,
  };
};
